export const renderMaxErrorMessage =
	(translate: (key: string) => string) =>
	({ max }: { max: number }) => {
		return `${translate("number-limit-is")} ${max}`;
	};
